import { v4 as uuidv4 } from 'uuid'
import { NoteRoute } from '@/modules/note/v1/api/NoteRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { ChunkParams } from '@/modules/note/v1/api/v1/files/Dto/ChunkParams'
import { Upload } from '@/modules/note/v1/api/v1/files/Dto/Upload'

/** PUT /api/note/v1/uploads/{upload}: кусок сессии с Content-Range, тело — байты (sendBytes) */
export class SendChunkRoute extends NoteRoute<ChunkParams, Upload> {
  constructor(private readonly upload: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.PUT
  }

  url(): string {
    return '/api/note/v1/uploads/' + this.upload
  }

  bytesHeaders(params: ChunkParams): Record<string, string> {
    return { 'Content-Range': `bytes ${params.from}-${params.to}/${params.size}` }
  }

  /** Без сервера кусок принят; последний кусок даёт UUID файла */
  offline(params: ChunkParams): Promise<ApiResponse<Upload>> {
    const received = params.to + 1
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new Upload({ upload: this.upload, size: params.size, received, file: received >= params.size ? uuidv4() : null }),
    }))
  }
}
